module.exports = __webpack_public_path__ + "assets/img/goods_adv7.4a0c82c1.jpg";